// This file is auto-generated during build
export const version: string = "18.0_2611";
